const { MODE, VITE_GLUE_API_URL } = import.meta.env

const isProduction = MODE === 'production'

export const GLUE_API_URL =
  VITE_GLUE_API_URL ||
  (isProduction
    ? 'https://glue.partner.fondof.de'
    : 'https://glue.stage-partner.fondof.de')
